// src/services/webhookLogService.ts
import { apiClient } from './apiClient';

const webhookLogService = {
  // Get all webhook delivery logs with pagination and filters
  getAllLogs: async (payload: any): Promise<any> => {
    try {
      let queryString = '';
      if (payload) {
        const params = new URLSearchParams();
        Object.keys(payload).forEach(key => {
          if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
            params.append(key, payload[key].toString());
          }
        });
        queryString = params.toString();
      }

      const url = `webhook-logs${queryString ? `?${queryString}` : ''}`;
      return await apiClient.get(url);
    } catch (error) {
      throw error;
    }
  },

  // Get a single webhook log (with full payload) by ID
  getLogById: async (logId: any): Promise<any> => {
    try {
      return await apiClient.get(`webhook-logs/${logId}`);
    } catch (error) {
      throw error;
    }
  },
};

export default webhookLogService;
